import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "about-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "about-amb",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "orb o1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "orb o2" })
], -1)
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<span class=\"hero-mark\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M3 8h11a3 3 0 1 0-3-3\"></path><path d=\"M3 12h15a3 3 0 1 1-3 3\"></path><path d=\"M3 16h9\"></path></svg></span><span class=\"eyebrow\">하나의 계정, 여러 서비스</span><h1 class=\"hero-title\">일상에 필요한 도구들,<br><span class=\"accent\">breezer</span> 하나로.</h1><p class=\"hero-desc\"> 로또 분석부터 아파트 실거래가, 옷장 관리와 경조사 기록까지 — 흩어져 있던 서비스를 계정 하나로 가볍게. 필요한 순간 바로 꺼내 쓰세요. </p>", 4)
const _hoisted_8 = { class: "hero-cta" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#services",
  class: "btn-primary"
}, "서비스 둘러보기", -1)
const _hoisted_10 = {
  id: "services",
  class: "services"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "sec-head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "서비스"),
  /*#__PURE__*/_createElementVNode("p", null, "필요한 걸 골라 바로 들어가세요. 외부 서비스도 같은 계정으로 연결됩니다.")
], -1)
const _hoisted_12 = { class: "service-grid" }
const _hoisted_13 = { class: "card-tile" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = {
  key: 0,
  class: "ext"
}
const _hoisted_16 = { class: "card-desc" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "card-go" }, [
  /*#__PURE__*/_createTextVNode(" 바로가기 "),
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.4",
    "stroke-linecap": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14M13 6l6 6-6 6" })
  ])
], -1)
const _hoisted_18 = { class: "content-highlights" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "sec-head" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "주요 콘텐츠")
], -1)
const _hoisted_20 = { class: "highlight-list" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-label" }, "부동산 소식", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-text" }, "매월 정리하는 부동산 시장 동향 리포트 — 금리 변화, 정책 이슈, 서울 주요 지역 시세 분석을 확인하세요.", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-label" }, "부동산 용어사전", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-text" }, "전매제한, DTI, 재건축초과이익부담금 등 부동산 거래에 꼭 필요한 40여 개 핵심 용어를 카테고리별로 쉽게 찾아보세요.", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-label" }, "로또 당첨 결과", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-text" }, "최신 로또 회차별 당첨 번호와 1등~5등 당첨금 정보를 빠르게 확인하고, 번호 출현 빈도 통계를 분석해 보세요.", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-label" }, "아파트 실거래가 조회", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "highlight-text" }, "국토교통부 실거래가 공개 시스템 데이터를 기반으로 서울 25개 자치구의 아파트 매매 실거래가를 검색하고 시세 흐름을 파악하세요.", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("section", { class: "about-intro" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "intro-text" }, " Breezer는 일상에서 자주 필요하지만 흩어져 있던 생활 정보들을 한곳에 모아 제공하는 웹 서비스입니다. 로또 당첨 번호 분석과 자동 번호 생성, 국토교통부 공공데이터 기반 서울 아파트 실거래가 조회, 매월 정리하는 부동산 시장 동향 리포트, 부동산 용어사전 등 신뢰할 수 있는 데이터를 기반으로 유용한 정보를 제공합니다. "),
  /*#__PURE__*/_createElementVNode("p", { class: "intro-text" }, " 또한 인스타그램 맞팔 확인, 경조사 내역 관리, 신체 치수 및 의류 사이즈 기록 등 개인 생활을 편리하게 관리할 수 있는 도구도 함께 제공합니다. 모든 서비스는 무료로 이용 가능하며, 회원가입 없이도 대부분의 조회 기능을 사용할 수 있습니다. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_router_link, {
          to: "/user/login",
          class: "btn-ghost"
        }, {
          default: _withCtx(() => [
            _createTextVNode("로그인")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featureCards, (card) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(card.external ? 'a' : 'router-link'), _mergeProps({
            key: card.name,
            ref_for: true
          }, card.external ? { href: card.path } : { to: card.path }, {
            class: ["feature-card", 'acc-' + card.accent]
          }), {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, _toDisplayString(card.icon), 1),
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(card.name), 1),
                (card.external)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "외부 ↗"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, _toDisplayString(card.desc), 1),
              _hoisted_17
            ]),
            _: 2
          }, 1040, ["class"]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_router_link, {
          to: "/apt/news",
          class: "highlight-item"
        }, {
          default: _withCtx(() => [
            _hoisted_21,
            _hoisted_22
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/apt/glossary",
          class: "highlight-item"
        }, {
          default: _withCtx(() => [
            _hoisted_23,
            _hoisted_24
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/lotto/result",
          class: "highlight-item"
        }, {
          default: _withCtx(() => [
            _hoisted_25,
            _hoisted_26
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/apt/trade",
          class: "highlight-item"
        }, {
          default: _withCtx(() => [
            _hoisted_27,
            _hoisted_28
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_29
  ]))
}